import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const Security2 = ({ style, size = 16, fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.icon.default;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <mask id="mask0_security2" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width={size} height={size} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_security2)">
        <path
          d="M7.29984 10.3666L11.0665 6.59992L10.1165 5.64992L7.29984 8.46658L5.89984 7.06659L4.94984 8.01659L7.29984 10.3666ZM7.99984 14.6666C6.45539 14.2777 5.18039 13.3916 4.17484 12.0083C3.16928 10.6249 2.6665 9.08881 2.6665 7.39992V3.33325L7.99984 1.33325L13.3332 3.33325V7.39992C13.3332 9.08881 12.8304 10.6249 11.8248 12.0083C10.8193 13.3916 9.54428 14.2777 7.99984 14.6666Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
